import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  transFetchData,
  setRef,
  loginPost,
  getTourStatus,
} from "./../../redux/actions/appActions";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import Routes from "./../routes";
import Trans from "./../../componentsReusable/trans";
import Loader from "./../loader";
import ErrorBoundary from "./../errorBoundary";
import PopupAlert from "./../popupAlert";
// import ErrorPage from './../supportPages/errorPage';

class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goAhead: false,
      objInvite: {},
      isOffline: !navigator.onLine,
    };
    this.refWrapper = React.createRef();
  }

  handleOnline = () => {
    this.setState({ isOffline: false });
  };

  handleOffline = () => {
    this.setState({ isOffline: true });
  };

  componentDidMount() {
    this.loadGame();
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  render() {
    const self = this;
    const { refWrapper, props, state } = self;
    const { propsAlert } = props;
    const { isOffline } = state;
    let nodeLoader = <Loader />;

    let nodeOrientation = (
      <div className="si-orientation__wrap">
        <div className="si-orientation__box">
          <div className="si-orientation__thumb">
            <img src={`${config.IMG_BASE}landscape-orientation.svg`} alt="" />
          </div>
          <div className="si-orientation__text">
            <span>
              <Trans sKey={"pleaseTurnDevice"} />
            </span>
          </div>
        </div>
      </div>
    );

    let nodeBody = self.state.goAhead ? (
      <Routes {...props} nodeLoader={nodeLoader} />
    ) : (
      nodeLoader
    );
    return (
      <ErrorBoundary>
        <div className={`si-main ${isOffline ? "si-noPointer" : ""}`} ref={refWrapper} id="si-main">
          {nodeBody}
          <PopupAlert {...propsAlert} />
        </div>
      </ErrorBoundary>
    );
  }
  init = () => {
    const self = this;
    const { setRef } = self.props;
    const cookie = app.getLoginCookie();
    const transPromise = self.props.transFetchData();
    const tourStatusPormise = self.props.getTourStatus();
    let arrAPI = [transPromise, tourStatusPormise];
    Promise.all(arrAPI)
      .then((resp) => {
        if (
          resp &&
          resp.length &&
          resp[0].value.data.value &&
          resp[1].value.data.Meta.RetVal
        ) {
          self.setState({ goAhead: true });
        }
      })
      .catch((reason) => {
        console.log(reason);
      });
    setRef && setRef({ refWrapper: self.refWrapper });
  };
  /* componentDidUpdate(prevProps, prevState) {
      const self = this;
      const { setRef } = self.props;
      const { goAhead: goAheadOld } = prevState;
      const { goAhead } = self.state;
      const sOld = goAheadOld ? goAheadOld.toString() : '0';
      const sNew = goAhead ? goAhead.toString() : '0';
      if (sOld !== sNew) {
          setRef && setRef({ refWrapper: self.refWrapper });
      }
  } */

  queryParams = app.getQueryParamsObject;
  isWebview = this.queryParams.webview;

  loadGame = () => {
    const { loginPost } = this.props;
    const objStatus = app.getLoginStatus();
    // const cookie = app.getLoginCookie();
    const guidCookie = core.getCookie(config.COOKIE_GUID);
    const { status, parentCookie } = objStatus;
    if (status === config.enumCookieStatus.both) {
      loginPost &&
        loginPost({ guid: parentCookie.user_guid })
        .then((resp) => {
          // console.log("resp :", resp);
          const parentGuid = parentCookie.guid;
          const retVal =
            resp &&
            resp.action.payload.data &&
            resp.action.payload.data &&
            resp.action.payload.data.meta &&
            resp.action.payload.data.meta.retVal;
          if (retVal === 2) {
            window.location.href = "/profile?cbkurl=/games/predictor/home";
          }
          if(retVal === -997 || retVal === -995){
            core.deleteCookie(config.COOKIE_FANTASY);
            core.deleteCookie(config.COOKIE_007);
            core.deleteCookie(config.parentCookie);
            app.onLogin();
          }
          if (retVal === -999) {
            const $loginParent = document.querySelector("ul.sub-ul .icon-user");
            if ($loginParent && $loginParent.click) {
              $loginParent.click();
            }
          }
          core.setCookie(config.COOKIE_GUID, parentGuid, 365);
          this.init();
        })
        // .catch((error) => {
        //   if (error?.response && (error?.response?.status == 401 || error?.response?.status == -997)) {
        //     core.deleteCookie(config.COOKIE_FANTASY);
        //     core.deleteCookie(config.COOKIE_007);
        //     core.deleteCookie(config.parentCookie);
        //     // app.deleteAllCookies(true);
        //     app.onLogin();
        //     // app.getLoginCookie()()
        //   }
        // });

      // commented this code as need to call Login API again and again
      // if (parentCookie.guid !== guidCookie) {
      //   //call login &
      //   loginPost &&
      //     loginPost({ guid: parentCookie.user_guid }).then((resp) => {
      //       // console.log("resp :", resp);
      //       const parentGuid = parentCookie.guid;
      //       const retVal =
      //         resp &&
      //         resp.action.payload.data &&
      //         resp.action.payload.data &&
      //         resp.action.payload.data.meta &&
      //         resp.action.payload.data.meta.RetVal;
      //       if (retVal === 2) {
      //         window.location.href = "/profile?cbkurl=/games/predictor/home";
      //       }
      //       if (retVal === -999) {
      //         const $loginParent = document.querySelector(
      //           "ul.sub-ul .icon-user"
      //         );
      //         if ($loginParent && $loginParent.click) {
      //           $loginParent.click();
      //         }
      //       }
      //       core.setCookie(config.COOKIE_GUID, parentGuid, 365);
      //       this.init();
      //     });
      // } else {
      //   //normal
      //   this.init();
      // }
    }
    // if mismatch the condition guid basis code if requires ...
    // else if (status === config.enumCookieStatus.missMatch) {
    //   //delete all cookie &
    //   core.deleteCookie(config.COOKIE_FANTASY);
    //   core.deleteCookie(config.COOKIE_007);
    //   this.loadGame();
    // }
    else if (this.isWebview && status !== config.enumCookieStatus.onlyChild) {
      let temp_guid = Date.now();
      loginPost &&
        loginPost({ guid: temp_guid }).then((resp) => {
          const parentGuid = temp_guid;
          const retVal =
            resp &&
            resp.action.payload.data &&
            resp.action.payload.data.meta &&
            resp.action.payload.data.meta.retVal;
          // if (retVal === 2) {
          //   window.location.href = "/profile?cbkurl=/games/predictor/home";
          // }
          if (retVal === -999) {
            const $loginParent = document.querySelector("ul.sub-ul .icon-user");
            if ($loginParent && $loginParent.click) {
              $loginParent.click();
            }
          }
          if(retVal === -997 || retVal === -995){
            core.deleteCookie(config.COOKIE_FANTASY);
            core.deleteCookie(config.COOKIE_007);
            core.deleteCookie(config.parentCookie);
            app.onLogin();
          }
          core.setCookie(config.COOKIE_GUID, parentGuid, 365);
          this.init();
        });
    } else if (status === config.enumCookieStatus.onlyParent) {
      //call login &
      loginPost &&
        loginPost({ guid: parentCookie.user_guid }).then((resp) => {
          // console.log("resp :", resp);
          const parentGuid = parentCookie.guid;
          const retVal =
            resp &&
            resp.action.payload.data &&
            resp.action.payload.data &&
            resp.action.payload.data.meta &&
            resp.action.payload.data.meta.retVal;

          if (retVal === 2) {
            window.location.href = "/profile?cbkurl=/games/predictor/home";
          }

          if(retVal == -997 || retVal == -995){
            core.deleteCookie(config.COOKIE_FANTASY);
            core.deleteCookie(config.COOKIE_007);
            core.deleteCookie(config.parentCookie);
            app.onLogin();
          }

          if (retVal === -999) {
            const $loginParent = document.querySelector("ul.sub-ul .icon-user");
            if ($loginParent && $loginParent.click) {
              $loginParent.click();
            }
          }
          
          core.setCookie(config.COOKIE_GUID, parentGuid, 365);
          this.init();
        });
    } else if (status === config.enumCookieStatus.onlyChild) {
      //delete all cookie &
      core.deleteCookie(config.COOKIE_FANTASY);
      core.deleteCookie(config.COOKIE_007);
      core.deleteCookie(config.COOKIE_GUID);
      this.loadGame();
      // this.init();
    } else {
      //normal
      this.init();
    }
  };
}
const mapStateToProps = (state) => {
  return {
    trans: state.appData.trans,
    userEotStatus: state.appData.userEotStatus,
    jErrorcode: state.appData.jErrorcode,
    propsAlert: state.appData.propsAlert,
    tourStatus: state.appData.tourStatus,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    transFetchData: () => dispatch(transFetchData()),
    loginPost: (payload) => dispatch(loginPost(payload)),
    setRef: (payload) => dispatch(setRef(payload)),
    getTourStatus: () => dispatch(getTourStatus()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
